import { deleteDoc, doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { FIRESTORE_COLLECTIONS, firestore } from '../firebase';

type BlockSource = 'chat' | 'public_profile';

export function getBlockedUserPath(currentUserId: string, blockedUserId: string) {
  return `${FIRESTORE_COLLECTIONS.users}/${currentUserId}/blockedUsers/${blockedUserId}`;
}

export async function blockUser(currentUserId: string, blockedUserId: string, source: BlockSource) {
  if (!currentUserId || !blockedUserId || currentUserId === blockedUserId) {
    throw new Error('Invalid block target');
  }

  const blockRef = doc(firestore, FIRESTORE_COLLECTIONS.users, currentUserId, 'blockedUsers', blockedUserId);
  const path = getBlockedUserPath(currentUserId, blockedUserId);

  try {
    const existingBlock = await getDoc(blockRef);

    if (!existingBlock.exists()) {
      await setDoc(blockRef, {
        blockedUserId,
        blockedAt: serverTimestamp(),
        source,
      });
    } else {
      await setDoc(blockRef, {
        blockedUserId,
        blockedAt: existingBlock.data().blockedAt ?? serverTimestamp(),
        source,
      }, { merge: true });
    }
  } catch (error) {
    console.warn('[Tonyte][RN][Block] primary block write failed', {
      path,
      currentUserId,
      blockedUserId,
      error,
    });
    throw error;
  }

  await setDoc(doc(firestore, FIRESTORE_COLLECTIONS.blocks, `${currentUserId}_${blockedUserId}`), {
    blockerId: currentUserId,
    blockedId: blockedUserId,
    blockedAt: serverTimestamp(),
    source,
  }, { merge: true }).catch(error => {
    console.warn('[Tonyte][RN][Block] compatibility block write skipped', { blockedUserId, error });
  });
}

export async function blockUserFromChat(currentUserId: string, blockedUserId: string) {
  return blockUser(currentUserId, blockedUserId, 'chat');
}

export async function blockUserFromPublicProfile(currentUserId: string, blockedUserId: string) {
  return blockUser(currentUserId, blockedUserId, 'public_profile');
}

export async function unblockUser(currentUserId: string, blockedUserId: string) {
  if (!currentUserId || !blockedUserId) return;

  await deleteDoc(doc(firestore, FIRESTORE_COLLECTIONS.users, currentUserId, 'blockedUsers', blockedUserId));

  await deleteDoc(doc(firestore, FIRESTORE_COLLECTIONS.blocks, `${currentUserId}_${blockedUserId}`)).catch(error => {
    console.warn('[Tonyte][RN][Block] compatibility block delete skipped', { blockedUserId, error });
  });
}
